<template>
  <!-- <ScreenAdapter>
   
  </ScreenAdapter> -->
  <div class="fff">
    <Aside></Aside>
    <Header />
    <div class="container">
      <div class="history-content" v-if="bzyqData&&bzyqData.length>0">
        <div class="content-header" ref="208">
          <div class="text">标准要求</div>
        </div>
        <div class="content-box">
          <div class="swiper">
            <swiper :options="swiperOption">
              <swiper-slide v-for="item,index in bzyqData" :key="index">
                <div class="cover" :style="`background:url(${item.photo}) no-repeat center/cover;`" @click="jumpDetail(item)"></div>
              </swiper-slide>
            </swiper>
            <template v-if="bzyqData&&bzyqData.length>3">
              <div class="b swiper-pagination" slot="pagination"></div>
              <div class="b swiper-button-next">
              </div>
              <div class="b swiper-button-prev">
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="accept-content bg" v-if="cxlcData&&cxlcData.length>0">
        <div class="content-header" ref="209">
          <div class="text">程序流程</div>
        </div>
        <div class="content-box">
          <div class="item" @click="jumpDetail(item)" v-for="item,index in cxlcData.slice(0,1)" :key="index">
            <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>
      </div>

      <div class="accept-content" v-if="ffzdData&&ffzdData.length>0">
        <div class="content-header" ref="210">
          <div class="text">方法指导</div>
        </div>
        <div class="content-box">
          <div class="item" @click="jumpDetail(item)" v-for="item,index in ffzdData.slice(0,1)" :key="index">
            <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Custom/Party/Header"
import Footer from "@/components/Custom/Party/Footer"
// import ScreenAdapter from "@/components/ScreenAdapter"
import services from '@/config/services'
import utils from "../../../../config/utils"
import Aside from "../../../../components/Custom/Party/Aside.vue"
export default {
  data () {
    let that = this
    return {
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      swiperOption: {
        autoplay: {
          delay: 15000,
          disableOnInteraction: false
        },
        dynamicBullets: true,
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 41,
        pagination: {
          el: ".b.swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".b.swiper-button-next",
          prevEl: ".b.swiper-button-prev",
        },
        // loop: true,
      },
      thoughtSwiperOption: {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        effect: "coverflow",
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 0,
          stretch: 300,
          depth: 150,
          modifier: 1,
          slideShadows: false,
        },
        preventClicksPropagation: false,
        navigation: {
          // 前进后退按钮 ,不同版本配置方式不同
          nextEl: `.swiper-button-next.bzyq`,
          prevEl: `.swiper-button-prev.bzyq`,
        },
        pagination: {
          el: `.swiper-pagination.bzyq`,
        },
        on: {
          click: function (v) {
            let id = v.target.getAttribute("data-id");
            if (id) {
              window.open(`/center/${that.school_code}/custom/party/detail?id=${id}&key=join`, "_blank")
            }
          },
        },
      },
      bzyqData: [],
      cxlcData: [],
      ffzdData: []
    }
  },
  async mounted () {
    await this.getListData()
    await this.jumpPosition()
  },
  methods: {
    // 跳转到课程详情
    jumpDetail (item, key) {
      window.open(`/center/${this.school_code}/custom/party/detail?id=${item.id}&key=join`, "_blank")
    },
    // 锚点定位
    jumpPosition () {
      let that = this
      let position = that.$route.query.id
      if (position) {
        that.$nextTick(() => {
          let topVal = this.$refs[position].getBoundingClientRect().top
          document.body.scrollTop = topVal - 100
        })
      }
    },
    async getListData () {
      await services.getCourseList({ page: 1, size: 100, category_id: "208", school_code: this.school_code }).then(res => {
        this.bzyqData = res.data.items
      })

      await services.getCourseList({ page: 1, size: 100, category_id: "209", school_code: this.school_code }).then(res => {
        this.cxlcData = res.data.items
      })

      await services.getCourseList({ page: 1, size: 100, category_id: "210", school_code: this.school_code }).then(res => {
        this.ffzdData = res.data.items
      })


    },
  },
  components: {
    Header,
    Footer,
    Aside,
    // ScreenAdapter
  }
}
</script>

<style  lang="less" scoped>
* {
    font-family: Microsoft YaHei;
}
.container {
    width: 1200px;
    margin: 0 auto;
    padding: 14px 0 0;
    .content-header {
        width: 100%;
        height: 25px;
        position: relative;
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url('../../../../assets/custom/party/index/list-title.png')
            no-repeat center / cover;
        .text {
            font-size: 42px;
            font-weight: bold;
            background: linear-gradient(180deg, #b70000 70%, #ffcba5 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }
    .history-content {
        margin: 43px 0 14px;
        .content-header {
            margin-bottom: 35px;
        }
        .content-box {
            .swiper {
                position: relative;
                .swiper-slide {
                    width: 380px;
                    height: 214px;
                    overflow: hidden;
                    &:hover {
                        .cover {
                            transform: scale(1.2);
                        }
                    }
                }
                .cover {
                    width: calc(100%);
                    height: 100%;
                    cursor: pointer;
                    transition: all 0.7s;
                }
                ::v-deep .swiper-pagination {
                    margin-top: 24px;
                    display: flex;
                    justify-content: center;
                }
                ::v-deep .swiper-pagination-bullet {
                    width: 10px;
                    height: 10px;
                    background: #cdb29f;
                    border-radius: 50%;
                    display: block;
                    cursor: pointer;
                    &:not(:last-child) {
                        margin-right: 15px;
                    }
                }
                ::v-deep
                    .swiper-pagination-bullet.swiper-pagination-bullet-active {
                    background: #dd3639;
                }
                ::v-deep .swiper-button-next,
                ::v-deep .swiper-button-prev {
                    width: 17px;
                    height: 32px;
                    cursor: pointer;
                    display: block;
                }
                ::v-deep .swiper-wrapper {
                    position: unset !important;
                }
                ::v-deep .swiper-button-prev {
                    background: url('../../../../assets/hzvtc/list/swiper-prev.png')
                        no-repeat center/cover;
                    position: absolute;
                    top: 41%;
                    left: -24px;
                }

                ::v-deep .swiper-button-next {
                    background: url('../../../../assets/hzvtc/list/swiper-next.png')
                        no-repeat center/cover;
                    position: absolute;
                    top: 41%;
                    right: -24px;
                }
            }
        }
    }
    .accept-content {
        position: relative;
        top: 35px;
        margin: 0 0 25px;
        &.bg::before {
            content: '';
            width: 100vw;
            height: 1400px;
            background: url('../../../../assets/hzvtc/list/value-c-bg.png')
                no-repeat center/cover;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 110px;
        }
        &:not(.bg).content-header {
            margin: 40px 0 0;
        }
        .content-box {
            width: 100%;
            height: 730px;
            background: url('../../../../assets/hzvtc/list/vita-b-news.png')
                no-repeat center/cover;
            position: relative;
            margin-top: -24px;
            .item {
                cursor: pointer;
                width: 817px;
                height: 459px;
                box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                overflow: hidden;
                .c-img {
                    width: 100%;
                    height: 100%;
                    transition: all 0.7s;
                }
                &:hover {
                    .c-img {
                        transform: scale(1.2);
                    }
                }
            }
        }
    }
}
.fff {
    background: #fff;
}
</style>